import { onBeforeMount, Ref, ref } from "vue";
import { Handler, useLoading } from "./useLoading";
import { GetPromiseType } from "./types";

/**
 * 加载api并转换为data
 * @return [info, loading, onReload]
 */
export const useApiToState = <T extends () => Promise<any>>(api: T, defaultValue?: GetPromiseType<ReturnType<T>>): [
    Ref<GetPromiseType<ReturnType<T>>>,
    Ref<boolean>,
    () => Promise<void>,
    Handler,
] => {
    const [loading, handler] = useLoading();
    const info = ref<GetPromiseType<ReturnType<T>> | undefined>();
    const onReload = async () => {
        handler(async () => {
            info.value = await api();
            if (!info.value) {
                info.value = defaultValue;
            }
        });
    };
    onBeforeMount(onReload);
    return [
        info as Ref<GetPromiseType<ReturnType<T>>>,
        loading,
        onReload,
        handler,
    ];
};